import styled from 'styled-components';
import { GlobalToken } from 'antd';

interface ContainerProps {
  width: number;
  height: number;
  $mapView: number;
  theme: { token: GlobalToken };
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;

  .background {
    position: absolute;
    top: 0;
    left: 0;
    z-index: ${({ $mapView }) => $mapView};
  }

  .dessicant-dryer-maintenance {
    transform: scale(1.15);
  }
`;
